import React, { useContext, useMemo } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import * as NotifyUtils from "@repoflow/form-schema/notify";
import { ApolloProvider } from "@apollo/client";
import { BrowserRouter } from "react-router-dom";
import * as AccountComps from "@repoflow/components/account";

export const Context = React.createContext(null);

export const useAppContext = () => {
  return useContext(Context);
};

const originalConsoleError = console.error;
console.error = (message, ...args) => {
  if (typeof message === 'string' && message.includes('defaultProps will be removed')) {
    return;
  }
  originalConsoleError.apply(console, [message, ...args])
}

export const Provider = ({ client, basename, children }) => {
  const value = useMemo(
    () => ({/*app values HERE*/ }),
    []
  );

  return (
    <Context.Provider value={value}>
      <BrowserRouter basename={basename}>
        <DndProvider backend={HTML5Backend}>
          {client ? (
            <ApolloProvider client={client}>
              <AccountComps.Provider>{children}</AccountComps.Provider>
            </ApolloProvider>
          ) : (
            children
          )}
        </DndProvider>
      </BrowserRouter>
      <NotifyUtils.Handler />
    </Context.Provider>
  );
};
